import { makeVar, ReactiveVar } from "@apollo/client";

export type SharedStateType = {
  redirectURL: ReactiveVar<string | null>;
};

export const SharedState = {
  redirectURL: makeVar(null),
} as SharedStateType;
